import { Box, Flex, VStack } from "@chakra-ui/react";
import { GETLicensePayload } from "../utils";
import { PaymentBanner } from "./payment-banner";
import { WalletBalanceCard } from "./wallet-balance-card";
import { ActiveLicensesOverview } from "./active-licenses-overview";
import { NextBilling } from "./next-billing";

export const MASTER_PRICE = 99.9;
export const VO_PRICE = 9.9;

export function LicenseAndBilling({
  licenseData,
  onUpdateLicenses
}: {
  licenseData: Partial<GETLicensePayload>;
  onUpdateLicenses: (data?: GETLicensePayload) => void;
}) {
  return (
    <Box flex={1} maxW="4xl" w="full" mx="auto" px={4} py={8}>
      <VStack spacing={0} align="stretch">
        <Flex justify="space-between" align="center" mb="4">
          <Box>
            <Box as="h1" fontSize="2xl" fontWeight="bold" color="#1B2559">
              Licença de Usuários e Cobrança
            </Box>
            <Box color="gray.500" fontSize="sm" mt={1}>
              Gerencie suas assinaturas e pagamentos.
            </Box>
          </Box>
        </Flex>

        <PaymentBanner
          licenseData={licenseData}
          onUpdateLicenses={onUpdateLicenses}
        />

        <ActiveLicensesOverview licenseData={licenseData} />

        <WalletBalanceCard />

        <NextBilling
          licenseData={licenseData}
          onUpdateLicenses={onUpdateLicenses}
        />
      </VStack>
    </Box>
  );
}
